import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import recuperarPortugalLogo from '../../assets/recuperar-portugal-logo.webp';
import institutionalLogos from '../../assets/institutional-logos.webp';

const Footer = () => {
    const { t } = useTranslation();

    return (
        <footer className='bg-gray-900 text-white pt-12'>
            <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
                <div className='grid grid-cols-1 md:grid-cols-4 gap-8'>
                    <div>
                        <h3 className='text-lg font-semibold mb-4'>{t("footer.socialMedia")}</h3>
                        <div className='flex space-x-4'>
                            <a href="https://www.facebook.com/mergetime" target='_blank' rel='noopener noreferrer' className='hover:text-gray-300'>
                                <Facebook className='h-6 w-6' />
                            </a>
                            <a href='https://www.instagram.com/mergetimebs/' target='_blank' rel='noopener noreferrer' className='hover:text-gray-300'>
                                <Instagram className='h-6 w-6' />
                            </a>
                            <a href='https://www.linkedin.com/in/mergetime-bs-097b74195/' target='_blank' rel='noopener noreferrer' className='hover:text-gray-300'>
                                <Linkedin className='h-6 w-6' />
                            </a>
                        </div>
                    </div>

                    <div>
                        <h3 className='text-lg font-semibold mb-4'>{t("footer.usefulLinks")}</h3>
                        <ul className='space-y-2'>
                            <li><Link to="/" className='hover:text-gray-300'>{t("footer.usefulLinks.home")}</Link></li>
                            <li><Link to="/" className='hover:text-gray-300'>{t("footer.usefulLinks.services")}</Link></li>
                            <li><Link to="/about-us" className='hover:text-gray-300'>{t("footer.usefulLinks.aboutUs")}</Link></li>
                            <li><Link to="/contacts" className='hover:text-gray-300'>{t("footer.usefulLinks.contacts")}</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className='text-lg font-semibold mb-4'>{t("footer.contacts")}</h3>
                        <div className='space-y-2'>
                            <p className='font-semibold'>{t("footer.contacts.businessHours")}</p>
                            <p>{t("footer.contacts.schedule")}</p>
                            <p>{t("footer.contacts.email")}</p>
                            <p>{t("footer.contacts.phone")}</p>
                        </div>
                    </div>

                    <div>
                        <h3 className='text-lg font-semibold mb-4'>{t("footer.legal")}</h3>
                        <ul className='space-y-2'>
                            <li><Link to='/terms-conditions' className='hover:text-gray-300'>{t("footer.legal.terms")}</Link></li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Full-width white banner for institutional logos */}
            <div className="w-full bg-white py-4 my-8">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6">
                    <a
                        href="https://recuperarportugal.gov.pt/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="transition-opacity hover:opacity-90 flex-shrink-0"
                    >
                        <img
                            src={recuperarPortugalLogo}
                            alt="Recuperar Portugal"
                            className="h-10 sm:h-12 w-auto object-contain"
                        />
                    </a>
                    <img
                        src={institutionalLogos}
                        alt="Logos Institucionais (PRR, República Portuguesa, União Europeia NextGenerationEU)"
                        className="h-10 sm:h-12 w-auto object-contain"
                    />
                </div>
            </div>

            {/* Copyright section */}
            <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-6 text-sm text-center'>
                <p>© {new Date().getFullYear()} IA-Schedule. | {t("footer.copyright")}{' '}
                    <a href='https://merge-time.com/' target='_blank' rel='noopener noreferrer' className='text-gray-400 hover:text-gray-300 ml-1'>
                        {t("footer.company")}
                    </a>
                </p>
            </div>
        </footer>
    );
}

export default Footer;